import { useSelector } from 'react-redux';
import { useEffect } from 'react';

import { selectIsReportView } from 'util/selector/reportSelector';

import { useFeatureIsOn } from '@growthbook/growthbook-react';
import posthog from 'posthog-js';
import { selectUserId, selectRole } from 'reduxStore/user/selectors';
import { selectCurrentCompanyName } from 'reduxStore/project/selectors';
import { FeatureFlagEnum } from 'shared/constants/featureFlagEnum';

export const useIdentifyPostHog = () => {
  const userId = useSelector(selectUserId);
  const role = useSelector(selectRole);
  const isPosthogEnabled = useFeatureIsOn(FeatureFlagEnum.postHog);
  const companyName = useSelector(selectCurrentCompanyName);
  const isReportView = useSelector(selectIsReportView);

  useEffect(() => {
    if (!userId || !isPosthogEnabled || isReportView) {
      return;
    }

    posthog.identify(userId, { roles: [role], clients: companyName });
  }, [userId, role, isPosthogEnabled, companyName, isReportView]);
};
